import styled from 'styled-components';

import Chevron from '@icons/chevron.svg';

export const StyledChevron = styled(Chevron)`
  transform: rotate(-180deg);
  color: ${({ theme }) => theme.colors.typographyBodyLight};
`;
